<template>
  <div class="index" id="index" v-cloak>
    <!-- 顶部组件 -->
    <top-navigation
      :ewmShow1="ewmShow1"
      :maskType1="maskType1"
      @close="close"
    ></top-navigation>
    <!-- banner部分 -->
    <div class="swiper-container">
      <el-carousel height="360px" :interval="5000" arrow="never" ref="carousel">
        <!-- @click.native="goUrl()" -->
        <el-carousel-item
          v-for="(item, index) in carouselList"
          :key="index"
          @click.native="goUrl(item)"
        >
          <img class="picImg" :src="item.pictureUrl" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- block_1 -->
    <div class="block_1">
      <div class="text_box">
        <span class="t1">品牌圈</span>
        <span class="line"></span>
        <span class="t2" style="text-align: center">
          “品牌圈”是国内品牌学界的学者们共同发起，为从事品牌管理工作或进行品牌管理科学研究的广大学人提供品牌界资讯与资源的信息平台，进行品牌界实时新闻的动态传播、共享品牌研究的学术资源、学者间的互动交流。</span
        >
      </div>
      <div class="block_icon_box">
        <div class="icon_box">
          <!-- <div class="bgc">
            <div class="bgc_title">品牌圈动态</div>
            <div class="bgc_more" @click="$router.push({ path: '/newDetail' })">
              更多
            </div>
          </div>
          <div
            class="_conent"
            v-for="(item, index) in list.newsList"
            :key="index"
            @click="$router.push({ path: '/newDetail' })"
          >
            <div class="_conent_box">
              <div class="number">0{{ index + 1 }}</div>
              <div class="details">
                <p>{{ item.newsTitle }}</p>
                <div class="_time">{{ item.createTime }}</div>
              </div>
            </div>
          </div> -->
          <div class="imgBox">
            <img
              src="../../assets/image/index/pinpaidongtai.png"
              alt=""
              @click="$router.push({ path: '/newDetail' })"
            />
          </div>
        </div>
        <div class="icon_box">
          <!-- <div class="bgc1">
            <div class="bgc_title">卓闻专家团队</div>
            <div
              class="bgc_more"
              @click="$router.push({ path: '/teamDetail' })"
            >
              更多
            </div>
          </div>
          <div
            class="_team"
            @click="$router.push({ path: '/teamDetail' })"
            v-if="list"
          >
            <img :src="list.expertTermInfoList[0].expertUrl" alt="" />
            <div class="_teamConent">
              <div class="_teamName">
                {{ list.expertTermInfoList[0].expertName }}
              </div>
              <div class="_teamCone">
                {{ list.expertTermInfoList[0].expertPost }}
              </div>
            </div>
          </div>
          <div
            class="_team"
            @click="$router.push({ path: '/teamDetail' })"
            v-if="list"
          >
            <div class="_teamConent1">
              <div class="_teamName">
                {{ list.expertTermInfoList[1].expertName }}
              </div>
              <div class="_teamCone">
                {{ list.expertTermInfoList[1].expertPost }}
              </div>
            </div>
            <img :src="list.expertTermInfoList[1].expertUrl" alt="" />
          </div> -->
          <div class="imgBox">
            <img
              src="../../assets/image/index/xuehze.png"
              alt=""
              @click="$router.push({ path: '/teamDetail' })"
            />
          </div>
        </div>
        <div class="icon_box">
          <!-- <div class="bgc2">
            <div class="bgc_title">品牌研究资源</div>
            <div
              class="bgc_more"
              @click="$router.push({ path: '/resourceManage' })"
            >
              更多
            </div>
          </div>
          <div
            class="resources"
            v-for="(item, index) in list.thesisResourceList"
            :key="index"
            @click="goResources(item)"
          >
            <p>{{ item.name }}</p>
            <div class="resourcesBox">
              <div>{{ item.publishYear }}</div>
              <div>
                <i class="el-icon-view"></i>
                <span>{{ item.readCounts }}</span>
                <i class="el-icon-download"></i>
                <span>{{ item.downloadCounts }}</span>
              </div>
            </div>
          </div> -->
          <div class="imgBox">
            <img
              src="../../assets/image/index/xueshuziyuan.png"
              alt=""
              @click="$router.push({ path: '/resourceManage' })"
            />
          </div>
        </div>
        <div class="icon_box">
          <!-- <div class="bgc3">
            <div class="bgc_title">在线解答</div>
            <div class="bgc_more"></div>
          </div>
          <div class="answer">
            <div class="title">网站使用过程中有任何意见或建议都可以联系</div>
            <img src="../../assets/image/query/qrcode.png" alt="" />
            <div class="zhu">微信扫码 可在线交流哦～</div>
          </div> -->
          <div
            class="imgBox"
            @click.stop="(ewmShow1 = true), (maskType1 = true)"
          >
            <img src="../../assets/image/index/zaixianliaotian.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 数据化流程 -->
    <div class="pp_box">
      <div class="text_box">
        <span class="t1">品牌数据化实现流程</span>
        <span class="line"></span>
      </div>
      <div class="progress_img_box"></div>
    </div>
    <!-- block_2 -->
    <div class="block_2">
      <div class="text_box">
        <span class="t1">品牌数据标准化，是一切分析的前提</span>
        <span class="line"></span>
        <span class="t2"
          >卓闻数据依托国家标准《品牌评价 消费者感知测量指南》GB/T 39071-2020
          并将其作为品牌数据分析系统的研究准则。在研究过程、分析结果呈现等环节上支持私有化部署，建立规模化品牌数据库，助力各省市政府品牌管理部门迎接品牌数字化时代，帮助企事业单位实现品牌数据的标准化分析，增强品牌溢价能力，提高资产附加值。</span
        >
      </div>
      <div class="block_img_box"></div>
    </div>
    <!-- block_3 -->
    <div class="block_3">
      <div class="text_box">
        <span class="t1">联合发展和合作机构</span>
        <span class="line"></span>
      </div>
      <div class="block_img_box"></div>
    </div>
    <!-- 底部组件 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../../components/footer/footer.vue";
import topNavigation from "../../components/topNavigation/topNavigation.vue";
import { homePagePc, pcReadThesis } from "@/api/resourceManage";
import { getPicList } from "@/api/public";
export default {
  components: { topNavigation, Footer },
  data() {
    return {
      carouselList: "",
      list: "",
      ewmShow1: false,
      maskType1: false,
    };
  },
  created() {
    window.scrollTo(0, 0); // 回滚
  },
  mounted() {
    this.getData();
    this.getPicList();
  },
  methods: {
    // 关闭扫码
    close(data) {
      this.ewmShow1 = data.ewmShow;
      this.maskType1 = data.maskType;
    },
    // 打开pdf
    goResources(item) {
      pcReadThesis({ id: item.id }).then((res) => {
        if (res.code == 200) {
          window.open(item.fileUrl, "_blank");
          this.getData();
        }
      });
    },
    // 轮播图点击跳转
    goUrl(item) {
      if (item.jumpLink) {
        // let activeIndex = this.$refs.carousel.activeIndex;
        // window.open(this.carouselList[activeIndex].jumpLink);
        window.open(item.jumpLink);
      }
    },
    // 获取官网Pc-官网轮播图List
    getPicList() {
      getPicList().then((res) => {
        if (res.code == 200) {
          this.carouselList = res.data;
        }
      });
    },
    // 获取官网Pc-品牌资源,动态,卓闻团队
    getData() {
      homePagePc().then((res) => {
        if (res.code == 200) {
          this.list = res.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
// vue 防闪烁
[v-cloak] {
  display: none;
}
@media screen and (min-width: 0px) and (max-width: 1440px) {
  .mt {
    width: 1440px;
    margin: 0 auto;
  }
  .index {
    width: 1440px;
    .queryDetails {
      width: 1440px;
      .query_nav {
        min-width: 1440px;
        ._navBox {
          padding-left: 5px;
          padding-right: 5px;
          box-sizing: border-box;
        }
      }
    }
  }
}
@media screen and (min-width: 1441px) and (max-width: 1920px) {
  .mt {
    width: 1680px;
    margin: 0 auto;
  }
  .index {
    min-width: 1680px;
    .queryDetails {
      min-width: 1680px;
      .query_nav {
        min-width: 1680px;
      }
    }
  }
}
.index {
  background-color: #fff;
  .swiper-container {
    width: 100%;
    height: 360px;
    .picImg {
      width: 100%;
      height: 100%;
    }
  }
  .text_box {
    width: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    .t1 {
      font-size: 24px;
      line-height: 32px;
      color: #427bd5;
    }
    .line {
      margin-top: 12px;
      width: 68px;
      height: 4px;
      background: #427bd5;
      border-radius: 2px;
    }
    .t2 {
      width: 1103px;
      margin-top: 18px;
      font-size: 18px;
      line-height: 26px;
      color: #666666;
      text-indent: 2em;
    }
  }
  .block_1 {
    width: 100%;
    padding: 48px 0 86px;
    box-sizing: border-box;
    .block_icon_box {
      margin-top: 29px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .icon_box {
        display: flex;
        flex-flow: column;
        align-items: center;
        margin-right: 67px;
        width: 260px;
        height: 350px;
        background: #ffffff;
        box-shadow: 3px 6px 14px 0px #e4eefd;
        border-radius: 4px;
        img {
          width: 100%;
          height: 100%;
        }
        &.active {
          span {
            color: #427bd5;
          }
        }
        .bgc {
          width: 100%;
          height: 56px;
          background: url("../../assets/image/index/pinpaidonbgtai.png")
            no-repeat;
          padding: 0 8px 0 12px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          line-height: 56px;
          .bgc_title {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
          }
          .bgc_more {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            cursor: pointer;
          }
        }
        .bgc1 {
          width: 100%;
          height: 56px;
          background: url("../../assets/image/index/zhuanjiatuandui.png")
            no-repeat;
          padding: 0 8px 0 12px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          line-height: 56px;
          .bgc_title {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
          }
          .bgc_more {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            cursor: pointer;
          }
        }
        .bgc2 {
          width: 100%;
          height: 56px;
          background: url("../../assets/image/index/yanjiuziyuan.png") no-repeat;
          padding: 0 8px 0 12px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          line-height: 56px;
          .bgc_title {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
          }
          .bgc_more {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            cursor: pointer;
          }
        }
        .bgc3 {
          width: 100%;
          height: 56px;
          background: url("../../assets/image/index/zaixianjieda.png") no-repeat;
          padding: 0 8px 0 12px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          line-height: 56px;
          .bgc_title {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
          }
          .bgc_more {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            cursor: pointer;
          }
        }
        ._conent {
          width: 100%;
          height: 88px;
          background: #ffffff;
          ._conent_box {
            display: flex;
            justify-content: start;
            padding: 8px 20px 8px 8px;
            box-sizing: border-box;
            cursor: pointer;
            .number {
              width: 16px;
              font-size: 14px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 500;
              color: #588fe9;
              line-height: 21px;
              margin-right: 6px;
            }
            .details {
              p {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2; // 2行
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 26px;
              }
              ._time {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 17px;
              }
            }
          }
        }
        ._conent:hover {
          background: #ecf3fd;
          .index {
            background: #ecf3fd;
          }
          .details {
            background: #ecf3fd;
          }
        }
        ._team {
          width: 100%;
          display: flex;
          justify-content: space-between;
          padding: 12px 14px 12px 12px;
          box-sizing: border-box;
          cursor: pointer;
          img {
            width: 86px;
            height: 116px;
          }
          ._teamConent {
            margin-left: 8px;
            ._teamName {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 700;
              color: #333333;
              line-height: 22px;
              margin-bottom: 4px;
            }
            ._teamCone {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 20px;
            }
          }
          ._teamConent1 {
            margin-right: 8px;
            ._teamName {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 700;
              color: #333333;
              line-height: 22px;
              margin-bottom: 4px;
            }
            ._teamCone {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 20px;
            }
          }
        }
        .resources {
          width: 100%;
          padding: 10px 16px;
          box-sizing: border-box;
          cursor: pointer;
          p {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; // 2行
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 700;
            color: #333333;
            line-height: 26px;
          }
          .resourcesBox {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 17px;
            margin-top: 7px;
          }
        }
        .resources:hover {
          background: #ecf3fd;
        }
        .answer {
          text-align: center;
          padding: 16px 34px 16px 33px;
          box-sizing: border-box;
          .title {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 700;
            color: #333333;
            line-height: 24px;
          }
          img {
            width: 156px;
            height: 156px;
            margin-top: 10px;
          }
          .zhu {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999990;
            line-height: 24px;
          }
        }
      }
      .icon_box:last-child {
        margin-right: 0;
      }
    }
  }
  .pp_box {
    width: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    background-color: rgba(66, 123, 213, 0.05);
    padding: 65px 0 80px;
    box-sizing: border-box;
    .progress_img_box {
      margin-top: 48px;
      width: 1088px;
      height: 758px;
      background: url("../../assets/image/index/progress.gif") no-repeat;
      background-size: contain;
    }
  }
  .block_2 {
    width: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    padding: 84px 0;
    box-sizing: border-box;
    .block_img_box {
      margin-top: 32px;
      width: 1086px;
      height: 596px;
      background: url("../../assets/image/index/block_2_bg.png") no-repeat;
      background-size: contain;
    }
  }
  .block_3 {
    width: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    padding: 84px 0 52px;
    box-sizing: border-box;
    .block_img_box {
      margin-top: 52px;
      width: 1098px;
      height: 182px;
      background: url("../../assets/image/index/block_3_bg1.png") no-repeat;
      background-size: contain;
    }
  }
}
.imgBox {
  border-radius: 10px;
  overflow: hidden;
}
.imgBox:hover {
  box-shadow: 0 16px 32px 0 rgb(73, 69, 69); /* 盒子悬浮时阴影 */
  filter: brightness(1.3);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue